/* ==========================================================
   TABELLA DI CONFRONTO CUBE - PROVA
   20 agosto 2026. Nata accanto al confronto dell'app Tably, che dal 24
   agosto e' nascosto (non disinstallato): vedi la sezione in fondo a
   cube-confronto.css.

   COME SI SPEGNE, in trenta secondi: si tolgono le due righe di
   cube-confronto.css e cube-confronto.js da snippets/stylesheets.liquid.
   Sparisce il nostro bottone E ricompaiono quelli di Tably, perche' anche
   le regole che li nascondono stanno nel nostro foglio. Il negozio torna
   com'era senza restare un istante senza confronto. Anche i dati salvati
   nel browser (chiave "cube-confronto") sono nostri e non c'entrano con
   quelli di Tably.

   ==========================================================
   DA DOVE ARRIVANO I DATI
   ==========================================================
   Dai metafield, che vivono solo in Liquid: il JavaScript non li vede e
   /products/<handle>.js non li restituisce. Si chiedono a Shopify uno alla
   volta con l'API di rendering delle sezioni:

     /products/<handle>?section_id=cube-specs-json

   che disegna sections/cube-specs-json.liquid nel contesto di quel
   prodotto e restituisce solo quel pezzetto - misurato, 3-5 kB a bici
   invece dei centinaia della pagina intera.

   Le risposte si tengono in memoria per tutta la visita: riaprendo la
   finestra sugli stessi prodotti non parte nessuna richiesta.

   ==========================================================
   COLLAUDO SU TUTTO IL CATALOGO (20 agosto 2026)
   ==========================================================
   Provate tutte e 80 le bici attive, una per una: zero risposte rotte,
   zero JSON illeggibili. Settanta hanno la scheda tecnica completa, da 17
   a 37 voci. Dieci ne hanno due - codice e anno - perche' i metafield non
   sono stati compilati su quei prodotti, e non e' un problema di questo
   codice: e' un buco nei dati, e si chiude compilandoli.

   ==========================================================
   COSA E' STATO TOLTO, E PERCHE' RESTA SCRITTO QUI
   ==========================================================
   Tutto fra il 20 e il 25 agosto 2026, tutto su richiesta:

     SOLO LE DIFFERENZE   filtrava la tabella nascondendo le righe uguali.
     COPIA LINK           copiava un indirizzo con i prodotti scelti.
     la lineetta rossa    sotto il titolo, sostituita dal logo nero.
     "n prodotti a        "toglilo come scritta, e' inutile".
      confronto"
     l'avviso rosso       "scheda tecnica non disponibile" sulle colonne
                          senza metafield: "semplicemente troveranno i
                          campi vuoti".
     i divisori di        le fasce nere BICI, PESO E PORTATA, TELAIO E
     gruppo               SOSPENSIONI... - "non importano a nessuno".
     il filo azzurro      sulle righe che differiscono. La marcatura si
                          continua a calcolare (vedi tabella), non la
                          dipinge piu' nessuno.
     "CUBE" nel nome      nelle colonne del confronto e nelle pastiglie
                          della barra: negozio di un marchio solo,
                          ripeterlo non distingue niente.
     la fotina nelle      sostituita da una bici disegnata: vedi BICI
     pastiglie            qui sotto.

   I GRUPPI PERO' ESISTONO ANCORA, ed e' la parte da non fraintendere:
   sono spariti i TITOLI, non il raggruppamento. L'ordine delle righe
   continua a venire da li' - prima i dati della bici, poi peso e portata,
   poi telaio e sospensioni e cosi' via - perche' e' l'ordine della scheda
   tecnica, non l'ordine in cui i metafield capitano. Toglierlo davvero
   vorrebbe dire righe in ordine casuale. La struttura sta in
   sections/cube-specs-json.liquid.

   L'APERTURA DA INDIRIZZO RESTA. Il tasto che generava il link non c'e'
   piu', ma un indirizzo del tipo

     /collections/qualcosa?confronta=handle1,handle2,handle3

   apre ancora la finestra gia' pronta. Costa cinque righe, serve per
   provare la tabella senza cliccare in giro, e permette a chi sta in
   negozio di mandare a un cliente un confronto gia' fatto scrivendo
   l'indirizzo a mano.

   IL LOGO IN TESTATA e' un <span> vuoto: l'immagine gliela mette il CSS,
   perche' questo file e' un asset e non passa da Liquid - qui non si puo'
   scrivere ne' asset_url ne' file_url. Vedi .cube-cfr-testa__logo in
   cube-confronto.css.
   ========================================================== */
(function () {
  'use strict';

  var CHIAVE = 'cube-confronto';
  var MAX = 4;
  var SEZIONE = 'cube-specs-json';
  var PARAM = 'confronta';

  /* i riquadri della chat Gorgias: il fumetto, la finestra e il messaggio
     che compare da solo. Si riconoscono dalla classe, che l'app genera con
     una coda casuale (gorgias-chat-key-1vly0ou) ma comincia sempre cosi' */
  var CHAT = 'iframe[class*="gorgias-chat"]';

  /* quanto resta alta la foto quando l'intestazione e' tutta chiusa.
     E' l'unico numero fisso di tutto il meccanismo: vedi comprimi(). */
  var FOTO_CHIUSA = 64;

  var LENTE =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M4 5h6v14H4zm10 0h6v14h-6zM6 8h2v2H6zm10 0h2v2h-2z"/></svg>';

  /* ==========================================================
     LA BICI DISEGNATA DELLE PASTIGLIE
     ==========================================================
     Chiesto il 25 agosto 2026: "al posto dell'immagine metti tipo un
     loghetto di una bici stilizzata".

     Prima li' c'era la foto vera del prodotto, in un riquadro di 34x24
     pixel. Alla prova dei fatti non si vedeva niente: le foto CUBE sono
     su fondo bianco e a quella misura la bici e' un filo grigio dentro
     un rettangolo bianco - nella barra nera sembravano tre francobolli
     vuoti, che e' esattamente come si vedono nella segnalazione.

     Al suo posto un disegno a tratto: due ruote, il triangolo del telaio,
     forcella, sella e manubrio. A trenta pixel di larghezza si legge
     benissimo perche' e' fatto di linee e non di sfumature, e sul nero
     funziona perche' prende il colore del testo intorno.

     E' SCRITTO QUI E NON NEL CSS, al contrario del logo della testata,
     perche' e' un contenuto che sta dentro ogni pastiglia: come sfondo
     andrebbe ripetuto e non potrebbe cambiare colore col resto. Le
     coordinate sono in un riquadro 32x22 - mozzo posteriore (7,15),
     anteriore (25,15), movimento centrale (16,15), sella (13,6),
     sterzo (21,6) - quindi si ritocca senza rifare i conti.

     LA FOTO CONTINUA A SALVARSI nella memoria del browser anche se qui
     non si usa piu': non costa niente ed e' gia' pronta se un domani si
     volesse rimettere una miniatura. La tabella del confronto le sue
     foto le prende comunque dal server, non da li'. */

  var BICI =
    '<svg viewBox="0 0 32 22" aria-hidden="true" focusable="false">' +
    '<circle cx="7" cy="15" r="6"/>' +
    '<circle cx="25" cy="15" r="6"/>' +
    '<path d="M7 15 L16 15 M16 15 L13 6 M7 15 L13 6 M16 15 L21 6 M21 6 L25 15 M13 6 L21 6"/>' +
    '<path d="M11.5 5 L14.5 5 M20 4.5 L22.5 4.5"/>' +
    '</svg>';

  var cache = {};
  var modale = null;

  /* ==========================================================
     LA COLONNA DELLE VOCI SI RIDUCE A ICONE (23 ottobre 2026)
     ==========================================================
     "questa colonna dove ci sono le voci voglio che mi dai la possibilita'
     di minimizzarla e quando e' minimizzata ci metti solo dei loghi che
     corrispondono" - Marco. Il tasto sta nella casella vuota in alto a
     sinistra; ridotta, la colonna e' larga 56 px (48 da telefono) e ogni
     voce mostra la sua icona a tratto, con il nome in un fumetto passandoci
     sopra o toccandola. La scelta resta per tutta la visita (chiave
     "cube-confronto-icone"). Una chiave senza icona prende il pallino. */
  var ICONE = {
    anno: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
    famiglia_prodotto: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="7.5" r="1.3"/>',
    gruppo_prodotto: '<path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z"/>',
    tipo_prodotto: '<path d="M2 20l7-11 4 6 3-4 6 9z"/>',
    misura: '<path d="M3 16L16 3l5 5L8 21z"/><path d="M7 12l2 2M10 9l2 2M13 6l2 2"/>',
    colore: '<path d="M12 3c3 4 6 7 6 11a6 6 0 0 1-12 0c0-4 3-7 6-11z"/>',
    codice: '<path d="M4 5v14M7 5v14M11 5v14M14 5v14M17 5v14M20 5v14"/>',
    peso: '<path d="M8.5 9.5a3.5 3.5 0 1 1 7 0"/><path d="M6.5 10h11l1.6 9.2a1 1 0 0 1-1 1.2H5.9a1 1 0 0 1-1-1.2z"/>',
    max_system_weight: '<path d="M12 4v16M6 20h12M4 8h16"/><path d="M4 8l-2.5 6a2.5 2.5 0 0 0 5 0zM20 8l-2.5 6a2.5 2.5 0 0 0 5 0z"/>',
    max_rider_weight: '<circle cx="12" cy="6.5" r="3.5"/><path d="M5 21c0-4 3-7 7-7s7 3 7 7"/>',
    telaio: '<path d="M4 18L10 7h9l-6 11z"/><path d="M10 7L9 4M19 7l1.5-3"/>',
    forcella: '<path d="M12 3v5M8 8h8M8 8v13M16 8v13"/>',
    ammortizzatore: '<path d="M12 2v3M12 19v3M7 5h10M7 19h10M8 7l8 2-8 2 8 2-8 2 8 2"/>',
    viteria_ammortizzatore: '<path d="M8 3h8v4H8zM12 7v14M9 10l6 1.5M9 13.5l6 1.5M9 17l6 1.5"/>',
    serie_sterzo: '<path d="M12 2v20M6 7h12M7.5 11h9M6 15h12"/>',
    motore: '<circle cx="12" cy="12" r="9"/><path d="M13 6l-4 7h4l-2 5 5-7h-4z"/>',
    batteria: '<rect x="2.5" y="7" width="16" height="10" rx="2"/><path d="M21 10.5v3M6 10v4M9.5 10v4M13 10v4"/>',
    display: '<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M9 20h6M12 16v4"/>',
    remote: '<rect x="8" y="2" width="8" height="20" rx="3"/><circle cx="12" cy="7" r="1.5"/><path d="M10.5 12h3M10.5 16h3"/>',
    caricabatteria: '<path d="M9 3v5M15 3v5M7 8h10v4a5 5 0 0 1-10 0zM12 17v4"/>',
    cambio: '<circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="6.5"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9L7 7M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1"/>',
    leva_del_cambio_freni: '<path d="M3 6h9a3 3 0 0 1 0 6H3"/><path d="M13 9l7 10"/>',
    guarnitura: '<circle cx="11" cy="11" r="7"/><circle cx="11" cy="11" r="2"/><path d="M11 11l7 7M16 20h5"/>',
    pacco_pignoni: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="3"/>',
    catena: '<rect x="2" y="8.5" width="11" height="7" rx="3.5"/><rect x="11" y="8.5" width="11" height="7" rx="3.5"/>',
    guidacatena: '<path d="M12 3l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6z"/>',
    freni: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="2.5"/><path d="M12 6.2v.1M17.8 12h-.1M12 17.8v-.1M6.2 12h.1"/>',
    ruote: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="1.5"/><path d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4"/>',
    copertoni: '<circle cx="12" cy="12" r="9.5"/><circle cx="12" cy="12" r="5.5"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1"/>',
    manubrio: '<path d="M2 9h4l3 3h6l3-3h4M12 12v8"/>',
    attacco_manubrio: '<path d="M4 17l11-7M15 10h5M4 13v8"/>',
    manopole: '<rect x="2" y="9" width="15" height="6" rx="3"/><path d="M17 12h5M7 9v6M11 9v6"/>',
    reggisella: '<path d="M8 5h8l-1.5 3h-5zM12 8v13M10 21h4"/>',
    sella: '<path d="M3 9c4-2 14-2 18 0-2 3-6 4-9 4-4 0-7-1-9-4zM12 13v7"/>',
    bloccaggio_sella: '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
    peso_netto: '<path d="M8.5 9.5a3.5 3.5 0 1 1 7 0"/><path d="M6.5 10h11l1.6 9.2a1 1 0 0 1-1 1.2H5.9a1 1 0 0 1-1-1.2z"/>',
    copertone_anteriore: '<circle cx="12" cy="12" r="9.5"/><circle cx="12" cy="12" r="5.5"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1"/>',
    copertone_posteriore: '<circle cx="12" cy="12" r="9.5"/><circle cx="12" cy="12" r="5.5"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1"/>'
  };

  function icona(chiave) {
    var corpo = ICONE[chiave] || '<circle cx="12" cy="12" r="3"/>';
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + corpo + '</svg>';
  }

  function iconeAccese() {
    try { return window.localStorage.getItem('cube-confronto-icone') === '1'; } catch (e) { return false; }
  }

  function impostaIcone(m, si) {
    m.classList.toggle('cube-cfr--icone', si);
    try { window.localStorage.setItem('cube-confronto-icone', si ? '1' : '0'); } catch (e) {}
    m.querySelectorAll('.cube-cfr-riduci').forEach(function (b) {
      b.setAttribute('aria-expanded', si ? 'false' : 'true');
      b.setAttribute('aria-label', si ? 'Mostra i nomi delle voci' : 'Riduci la colonna delle voci');
      var s = b.querySelector('span');
      if (s) s.textContent = si ? '' : 'Riduci menu';
    });
  }

  /* lo stile di MOSTRA DIFFERENZE (23 ottobre 2026): sta qui per non
     toccare cube-confronto.css; pillola come i tasti del sito, accesa in
     azzurro; la X accanto diventa un cerchio della stessa altezza, a 8 px (lo spazio del contenitore) e da computer col bordo destro allineato a RIMUOVI e al prezzo delle colonne ("avvicina i due tasti [...] fallo bene") ("la x falla con la cornice a cerchio" - Marco). Righe diverse su azzurro tenue, le uguali schiarite. */
  (function () {
    var st = document.createElement('style');
    st.textContent = [
      '.cube-cfr-diff{display:inline-flex;align-items:center;height:36px;margin-right:0;padding:0 16px;border:1px solid #d5d8db;border-radius:999px;background:#fff;color:#161616;font:800 11px/1 Inter,sans-serif;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap;cursor:pointer;transition:background-color .2s ease,color .2s ease,border-color .2s ease}',
      '.cube-cfr-diff:hover,.cube-cfr-diff:focus-visible{border-color:#0d82c5;color:#0a6ea6}',
      '.cube-cfr-diff[aria-pressed="true"]{background:#0d82c5;border-color:#0d82c5;color:#fff}',
      '.cube-cfr-diff:disabled{opacity:.5;cursor:default;border-color:#d5d8db;color:#80868d}',
      '.cube-cfr-et,.cube-cfr-val{transition:background-color .2s ease,opacity .2s ease,color .2s ease}',
      '.cube-cfr--differenze .cube-cfr-et.cube-cfr-riga--diversa,.cube-cfr--differenze .cube-cfr-val--diversa{background-color:#eaf3fb}',
      '.cube-cfr--differenze .cube-cfr-et.cube-cfr-riga--diversa{color:#0a6ea6}',
      '.cube-cfr--differenze .cube-cfr-val--diversa{color:#161616;font-weight:700}',
      '.cube-cfr--differenze .cube-cfr-et:not(.cube-cfr-riga--diversa),.cube-cfr--differenze .cube-cfr-val:not(.cube-cfr-val--diversa){opacity:.35}',
      '.cube-cfr-testa .cube-cfr-chiudi{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;padding:0;border:1px solid #d5d8db!important;border-radius:50%!important;background:#fff;color:#161616;line-height:1;transition:border-color .2s ease,color .2s ease,background-color .2s ease}',
      '.cube-cfr-testa .cube-cfr-chiudi:hover,.cube-cfr-testa .cube-cfr-chiudi:focus-visible{border-color:#161616!important;background:#161616;color:#fff}',
      '@media (min-width:750px){.cube-cfr-testa{padding-right:17px!important}}',
      '.cube-cfr-diff__corto{display:none}',
      /* da telefono una riga sola: logo a sinistra, tasti a destra; il
         titolo CONFRONTA LE BICI resta solo da computer ("da mobile non mi
         piace che vada sotto" - Marco) */
      '@media (max-width:749px){.cube-cfr-testa{flex-wrap:nowrap!important;justify-content:space-between}.cube-cfr-testa__titolo{display:none!important}.cube-cfr-testa__comandi{margin-left:auto;flex-shrink:0}.cube-cfr-diff__lungo{display:none}.cube-cfr-diff__corto{display:inline}}',
      '@media (max-width:749px){.cube-cfr-diff{height:32px;margin-right:0;padding:0 12px;font-size:10px;letter-spacing:.06em}.cube-cfr-testa .cube-cfr-chiudi{width:32px;height:32px}}',
      /* colonna delle voci riducibile */
      /* RIDUCI MENU largo quanto la casella ("estendilo in larghezza da
         lato a lato e metti riduci menu" - Marco); ridotta la colonna,
         resta il cerchietto con la freccia per riaprirla */
      '.cube-cfr-angolo{display:flex;align-items:flex-end;justify-content:center;padding:0 12px 14px}',
      '.cube-cfr-riduci{display:inline-flex;align-items:center;justify-content:center;width:100%;gap:8px;height:34px;padding:0 10px;border:1px solid #d5d8db;border-radius:999px;background:#fff;color:#161616;font:800 10.5px/1 Inter,sans-serif;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:border-color .2s ease,color .2s ease}',
      '.cube-cfr-riduci svg{width:14px;height:14px;transition:transform .25s ease}',
      '.cube-cfr-riduci:hover,.cube-cfr-riduci:focus-visible{border-color:#0d82c5;color:#0a6ea6}',
      '.cube-cfr--icone .cube-cfr-riduci{width:32px;height:32px;padding:0;justify-content:center;gap:0}',
      '.cube-cfr--icone .cube-cfr-angolo{padding:0 8px 14px}',
      '.cube-cfr--icone .cube-cfr-riduci svg{transform:rotate(180deg)}',
      '.cube-cfr-et__icona{display:none}',
      '.cube-cfr--icone .cube-cfr-griglia{grid-template-columns:56px repeat(var(--cube-cfr-colonne),minmax(0,1fr))!important}',
      '.cube-cfr--icone .cube-cfr-et{display:flex;align-items:center;justify-content:center;padding:0!important;cursor:help;outline:none}',
      '.cube-cfr--icone .cube-cfr-et__testo{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
      '.cube-cfr--icone .cube-cfr-et__icona{display:inline-flex;width:22px;height:22px}',
      '.cube-cfr--icone .cube-cfr-et__icona svg{width:100%;height:100%}',
      '.cube-cfr--icone .cube-cfr-et:hover,.cube-cfr--icone .cube-cfr-et:focus{z-index:6}',
      '.cube-cfr--icone .cube-cfr-et:hover::after,.cube-cfr--icone .cube-cfr-et:focus::after{content:attr(data-et);position:absolute;left:calc(100% + 6px);top:50%;transform:translateY(-50%);padding:7px 11px;border-radius:6px;background:#161616;color:#fff;font:800 10.5px/1.2 Inter,sans-serif;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap;box-shadow:0 8px 20px -8px rgba(0,0,0,.45);pointer-events:none}',
      '@media (max-width:749px){.cube-cfr--icone .cube-cfr-griglia{grid-template-columns:48px repeat(var(--cube-cfr-colonne),minmax(150px,1fr))!important}.cube-cfr-angolo{padding:0 8px 12px}.cube-cfr--icone .cube-cfr-angolo{padding:0 4px 12px}.cube-cfr-riduci{height:30px;gap:5px;padding:0 6px;font-size:9px;letter-spacing:.05em}.cube-cfr-riduci svg{width:12px;height:12px}.cube-cfr--icone .cube-cfr-riduci{width:30px;height:30px;padding:0}.cube-cfr--icone .cube-cfr-et__icona{width:20px;height:20px}}'
    ].join('');
    document.head.appendChild(st);
  })();

  /* ---------- memoria della selezione ---------- */
  /* Nel browser si salva il minimo indispensabile per disegnare la barra
     senza dover chiedere niente al server: handle, titolo e foto. La
     scheda tecnica non si salva mai - quella si richiede sempre fresca,
     perche' i metafield cambiano quando il negozio aggiorna i prodotti e
     una copia vecchia in memoria racconterebbe una bici che non esiste.

     IL TITOLO SI SALVA INTERO, con il "Cube" davanti e il colore in coda,
     e si accorcia solo al momento di scriverlo a schermo. Cosi' se un
     domani si cambia idea su cosa mostrare non serve che i clienti
     svuotino la selezione: basta cambiare come si stampa. */

  function leggi() {
    try {
      var v = JSON.parse(window.localStorage.getItem(CHIAVE) || '[]');
      return Array.isArray(v) ? v.slice(0, MAX) : [];
    } catch (e) {
      return [];
    }
  }

  function scrivi(elenco) {
    try {
      window.localStorage.setItem(CHIAVE, JSON.stringify(elenco.slice(0, MAX)));
    } catch (e) {
      /* navigazione privata o memoria piena: la selezione vale solo per
         questa pagina invece che per la visita. Meglio che non funzionare. */
    }
    disegna();
  }

  function dentro(handle) {
    return leggi().some(function (p) { return p.handle === handle; });
  }

  function aggiungi(p) {
    var e = leggi();
    if (e.some(function (x) { return x.handle === p.handle; })) return true;
    if (e.length >= MAX) return false;
    e.push(p);
    scrivi(e);
    return true;
  }

  function togli(handle) {
    scrivi(leggi().filter(function (p) { return p.handle !== handle; }));
  }

  /* ---------- leggere una scheda prodotto ---------- */

  function datiScheda(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    var href = link.getAttribute('href') || '';
    var m = href.split('?')[0].match(/\/products\/([^\/]+)/);
    if (!m) return null;

    var img = card.querySelector('img');
    var titolo = (card.querySelector('.spf-product-card__title') || link).textContent;

    return {
      handle: m[1],
      titolo: titolo.replace(/\s+/g, ' ').trim(),
      immagine: img ? (img.currentSrc || img.src || '') : ''
    };
  }

  /* ---------- il bottone sulle schede ---------- */

  function montaBottoni() {
    document.querySelectorAll('.cube-card-compare').forEach(function (box) {
      if (box.querySelector('.cube-cfr-btn')) return;

      var card = box.closest('.spf-product-card') || box.parentElement;
      if (!card) return;

      var dati = datiScheda(card);
      if (!dati) return;

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cube-cfr-btn';
      b.dataset.handle = dati.handle;
      b.innerHTML = LENTE + '<span></span>';
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (dentro(dati.handle)) {
          togli(dati.handle);
        } else if (!aggiungi(dati)) {
          avvisa('Al massimo ' + MAX + ' bici: togline una per aggiungerne un’altra.');
        }
      });

      box.appendChild(b);
    });

    aggiornaBottoni();
  }

  /* LE DUE SCRITTE DEL BOTTONE.
     A riposo diceva "Nuovo confronto" fino al 25 agosto 2026; cambiato in
     "Confronta" su richiesta - "al posto di scrivere NUOVO CONFRONTO
     scrivi CONFRONTA". Piu' corto e piu' diretto: dice cosa fa il tasto,
     non che tipo di confronto sta per cominciare. E siccome il bottone e'
     largo quanto la sua scritta (vedi .cube-cfr-btn in
     cube-confronto.css), accorciare il testo lo fa stringere da solo:
     misurato, da 152 a 108 pixel, ancora piu' lontano dalle ruote della
     bici.

     Premuto diventa "Nel confronto", che risponde alla domanda giusta -
     non "cosa fa questo tasto" ma "questa bici e' gia' dentro?". Insieme
     al fondo azzurro pieno dice due volte la stessa cosa, che su una
     griglia di quaranta schede serve.

     Il titolo della barra in fondo dice ancora "Nuovo confronto": li' e'
     l'intestazione della selezione che si sta costruendo, non un comando,
     e accanto ha gia' il suo tasto "Confronta (2)". */

  /* SI SCRIVE SOLO CIO' CHE CAMBIA (8 ottobre 2026). Prima stato e
     scritta si riscrivevano sempre, uguali. Ma riscrivere il testo dello
     <span> e' una modifica di figli: l'osservatore in fondo al file la
     vedeva e richiamava questa funzione al fotogramma dopo, all'infinito.
     Misurato sul catalogo: 48 bottoni riscritti 60 volte al secondo, 2.900
     modifiche al secondo a pagina ferma, e a cascata ripartivano anche
     gli osservatori di cube-collection.js e cube-filtri-scorri.js - la
     pagina lavorava sempre e scorrendo saltava un fotogramma ogni 60-80
     px: "ci sono punti dove la pagina scatta" - Marco. La selezione si
     legge una volta sola invece che una per bottone. */
  function aggiornaBottoni() {
    var scelti = {};
    leggi().forEach(function (p) { scelti[p.handle] = true; });
    document.querySelectorAll('.cube-cfr-btn').forEach(function (b) {
      var sel = !!scelti[b.dataset.handle];
      var stato = sel ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== stato) b.setAttribute('aria-pressed', stato);
      var s = b.querySelector('span');
      var testo = sel ? 'Nel confronto' : 'Confronta';
      if (s && s.textContent !== testo) s.textContent = testo;
    });
  }

  function avvisa(testo) {
    var b = barra();
    if (!b) { window.alert(testo); return; }
    var n = b.querySelector('.cube-cfr-bar__titolo');
    if (!n) return;
    var prima = n.textContent;
    n.textContent = testo;
    n.style.color = '#ff9d9d';
    setTimeout(function () { n.textContent = prima; n.style.color = ''; }, 3200);
  }

  /* ---------- la barra in basso ---------- */

  function barra() {
    return document.querySelector('.cube-cfr-bar');
  }

  /* LA BARRA DI TABLY NON C'E' PIU', MA IL POSTO GLIELO TENIAMO.
     Tably ne metteva una sua quando aveva dei prodotti selezionati, a
     z-index 2147482500: sovrapposte, vinceva sempre lei e la nostra era
     inutilizzabile. Invece di litigare sui numeri, la nostra si solleva
     da terra esattamente di quanto e' alta la loro, e si impilano.
     Dal 24 agosto 2026 quella barra e' nascosta (vedi cube-confronto.css)
     quindi il valore misura sempre zero: la logica resta come rete di
     sicurezza per il giorno in cui dovesse tornare.

     Si scrive solo se il valore e' cambiato: questa funzione viene
     chiamata anche dall'osservatore, e riscrivere uno stile a ogni giro
     lo farebbe ripartire all'infinito. */

  function posizionaBarra() {
    var b = barra();
    if (!b) {
      if (document.body.style.paddingBottom) document.body.style.paddingBottom = '';
      spostaChat();
      return;
    }

    var loro = document.querySelector('.tably-dynamic-bar');
    var sotto = loro && loro.offsetHeight ? loro.offsetHeight : 0;

    if (b.dataset.sotto !== String(sotto)) {
      b.dataset.sotto = String(sotto);
      b.style.setProperty('--cube-cfr-sotto', sotto + 'px');
    }

    var spazio = (b.offsetHeight + sotto) + 'px';
    if (document.body.style.paddingBottom !== spazio) {
      document.body.style.paddingBottom = spazio;
    }

    spostaChat();
  }

  /* ---------- il fumetto della chat si sposta da solo ----------

     Gorgias tiene il fumetto "Chiedi info" incollato in basso a destra, a
     20px da terra. La nostra barra e' alta una sessantina di pixel e parte
     da terra: il fumetto le finisce sopra, e copre proprio il tasto
     CONFRONTA. Misurato in pagina, non dedotto.

     Qui la chat viene alzata di quanto e' alta la barra e rimessa a posto
     appena la barra sparisce. Niente e' fisso a mano: se un domani la
     barra cambia altezza, il fumetto la segue.

     LA MISURA DI PARTENZA SI LEGGE UNA VOLTA SOLA e si tiene sul nodo
     stesso. Rileggerla a ogni giro vorrebbe dire leggere il valore che
     abbiamo appena scritto noi, e il fumetto salirebbe di sessanta pixel
     a ogni passata finche' non esce dallo schermo.

     SI SCRIVE CON !important perche' la chat porta i suoi valori in un
     foglio suo: senza, il nostro "bottom" verrebbe scavalcato. Quando non
     serve piu' si toglie proprio la dichiarazione, invece di rimettere un
     numero: cosi' comanda di nuovo Gorgias e non restiamo noi a decidere
     dove sta la sua chat - che infatti la sposta da sola a seconda di cosa
     sta mostrando (misurato: 10px o 20px a seconda del momento).

     QUANDO LA FINESTRA DEL CONFRONTO E' APERTA non serve spostare niente:
     la chat sta a z-index 2147483636, cioe' sopra a tutto, e per quello la
     nostra finestra e' salita a 2147483640 in cube-confronto.css. Li' il
     fumetto ci finisce dietro senza che si debba toccare. */

  function spostaChat() {
    var b = barra();
    var alzata = 0;

    if (b) {
      var sotto = parseInt(b.dataset.sotto || '0', 10) || 0;
      alzata = b.offsetHeight + sotto;
    }

    document.querySelectorAll(CHAT).forEach(function (f) {
      if (!f.dataset.cubeBase) {
        var base = parseInt(getComputedStyle(f).bottom, 10);
        f.dataset.cubeBase = isNaN(base) ? '20' : String(base);
      }

      if (!alzata) {
        if (f.style.bottom) f.style.removeProperty('bottom');
        return;
      }

      var vuole = (parseInt(f.dataset.cubeBase, 10) + alzata) + 'px';
      if (f.style.bottom !== vuole) f.style.setProperty('bottom', vuole, 'important');
    });
  }

  function disegna() {
    aggiornaBottoni();

    var elenco = leggi();
    var b = barra();

    /* ==========================================================
       LA FINESTRA SEGUE SEMPRE LA SELEZIONE, ANCHE QUANDO SI SVUOTA
       ==========================================================
       Qui c'era un difetto segnalato il 20 agosto 2026 - "tasti RIMUOVI
       non vanno" - e la diagnosi e' istruttiva perche' il tasto
       funzionava benissimo.

       Misurato: con due bici a confronto, un click su RIMUOVI portava la
       memoria da due handle a uno. La bici veniva tolta davvero. Solo che
       la finestra restava aperta sulla tabella di prima, con tutte e due
       le colonne al loro posto, quindi a schermo non succedeva niente.

       Il perche': questa riga chiamava apri() per ridisegnare, e apri()
       comincia con "se ci sono meno di due prodotti esci subito" - una
       guardia giusta, che serve a non aprire un confronto di uno solo.
       Ma passando da due a uno era proprio quella guardia a far uscire
       tutto senza ridisegnare niente. Con tre o quattro bici il tasto
       sembrava funzionare benissimo: si notava solo a due, cioe' nel caso
       piu' comune di tutti.

       Il peggio non era il tasto che sembrava morto, ma che la finestra
       raccontava una cosa falsa: mostrava due bici a confronto quando in
       memoria ce n'era una. Cliccando RIMUOVI anche sull'altra colonna la
       selezione si svuotava del tutto e la tabella restava li' identica.

       Adesso: se restano almeno due prodotti si ridisegna, se ne resta
       meno di uno la finestra si chiude - un confronto di una bici sola
       non esiste, e chiudendo si torna alla collezione con la bici
       rimasta ancora scelta nella barra in basso, pronta per accoppiarla
       a un'altra.

       E VA PRIMA DELL'USCITA PER ELENCO VUOTO qui sotto, non dopo: con
       la selezione svuotata da "Svuota" quel return se ne andava senza
       passare da qui, e la finestra restava aperta lo stesso. */
    if (modale && !modale.hidden) {
      if (elenco.length < 2) chiudi();
      else apri();
    }

    if (!elenco.length) {
      if (b) b.remove();
      document.body.style.paddingBottom = '';
      spostaChat();
      return;
    }

    if (!b) {
      b = document.createElement('div');
      b.className = 'cube-cfr-bar';
      b.innerHTML =
        '<span class="cube-cfr-bar__titolo">Nuovo confronto</span>' +
        '<div class="cube-cfr-bar__scelti"></div>' +
        '<div class="cube-cfr-bar__azioni">' +
        '<button type="button" class="cube-cfr-azione" data-azione="svuota">Svuota</button>' +
        '<button type="button" class="cube-cfr-azione cube-cfr-azione--principale" data-azione="apri"></button>' +
        '</div>';
      document.body.appendChild(b);

      b.querySelector('[data-azione="svuota"]').addEventListener('click', function () { scrivi([]); });
      b.querySelector('[data-azione="apri"]').addEventListener('click', function () { apri(); });
    }

    var scelti = b.querySelector('.cube-cfr-bar__scelti');
    scelti.textContent = '';

    /* NELLE PASTIGLIE IL NOME E' RIPULITO COME NELLE COLONNE.
       Chiesto il 25 agosto 2026: "il nome delle bici qui mettilo
       maiuscolo e senza la scritta cube all'inizio".

       Il "Cube" davanti lo toglie nomeModello, la stessa funzione che
       pulisce i titoli delle colonne del confronto: una regola sola per
       tutti e due i posti, cosi' non possono divergere.

       IL MAIUSCOLO INVECE LO FA IL CSS e non toUpperCase() qui: il testo
       resta scritto come nel catalogo, e chi naviga con un lettore di
       schermo sente "Stereo Hybrid ONE77" invece di rischiare che le
       sigle vengano lette lettera per lettera. Vedi .cube-cfr-chip span
       in cube-confronto.css.

       Nella pastiglia c'e' poco spazio - una decina di caratteri si
       perdono nei puntini - quindi togliere una parola che e' uguale su
       tutte le bici e' spazio guadagnato per quella che le distingue. */

    elenco.forEach(function (p) {
      var nome = nomeModello(p.titolo, coloreDaTitolo(p.titolo));

      var chip = document.createElement('div');
      chip.className = 'cube-cfr-chip';

      /* la bici disegnata al posto della fotina: vedi BICI in cima */
      chip.insertAdjacentHTML('beforeend', BICI);

      var s = document.createElement('span');
      s.textContent = nome;
      chip.appendChild(s);

      var x = document.createElement('button');
      x.type = 'button';
      x.setAttribute('aria-label', 'Togli ' + nome);
      x.textContent = '×';
      x.addEventListener('click', function () { togli(p.handle); });
      chip.appendChild(x);

      scelti.appendChild(chip);
    });

    var apriB = b.querySelector('[data-azione="apri"]');
    apriB.textContent = 'Confronta (' + elenco.length + ')';
    apriB.disabled = elenco.length < 2;

    posizionaBarra();
  }

  /* ---------- i dati ---------- */

  /* IL CONTROLLO SUL TITOLO NON E' PARANOIA. Un prodotto messo in bozza o
     archiviato risponde comunque 200, ma la sezione viene disegnata senza
     nessun prodotto dentro: titolo vuoto, prezzo vuoto, zero gruppi.
     Misurato su tre prodotti veri del catalogo. Dalle schede di una
     collezione non ci si arriva mai - un prodotto in bozza non e' in
     nessuna collezione - ma ci si arriva eccome da un indirizzo con
     ?confronta= salvato quando il prodotto era ancora pubblicato. Senza
     questo controllo la tabella mostrerebbe una colonna fantasma. */

  function carica(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);

    var radice = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';

    return fetch(radice + 'products/' + handle + '?section_id=' + SEZIONE, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nodo = doc.querySelector('script[data-cube-specs]');
        if (!nodo) throw new Error('senza dati');
        var d = JSON.parse(nodo.textContent);
        if (!d || !d.titolo) throw new Error('prodotto non disponibile');
        cache[handle] = d;
        return d;
      });
  }

  /* ==========================================================
     L'INTESTAZIONE SI ABBASSA MENTRE SI SCORRE
     ==========================================================
     Chiesto il 20 agosto 2026: "quando faccio lo scroll per vedere le
     caratteristiche voglio che la sezione sopra si abbassi, quando ritorno
     su deve tornare com'e' adesso - lo scroll segue le dimensioni".

     Il problema e' misurato: con le foto grandi l'intestazione ferma
     occupa 407px su una finestra alta 934, cioe' il 43%. Chi scorre per
     leggere forcella e cambio ha meno di meta' schermo di tabella. A
     intestazione chiusa scende a 153px, e le righe visibili passano da
     470px a 724.

     COME FUNZIONA. La foto non ha due stati: ha un'altezza che scende in
     modo continuo insieme allo scorrimento, e la corsa dura esattamente
     quanto l'altezza che c'e' da cedere. Tornando su rifa' la strada al
     contrario. Non c'e' nessuna soglia che scatta, quindi non c'e'
     nessuno scatto da vedere: e' letteralmente quello che e' stato
     chiesto, "lo scroll segue le dimensioni".

     PERCHE' NON UNA CLASSE CHE SI ACCENDE A UNA SOGLIA, che sarebbe stato
     tre righe: l'intestazione fa parte della griglia, quindi
     rimpicciolendola di colpo tutte le righe sotto risalirebbero di
     duecentocinquanta pixel in un fotogramma, e chi sta leggendo si
     ritroverebbe altrove nella tabella senza aver mosso la rotella.

     ==========================================================
     I TRE INCIDENTI DEL PRIMO GIRO, perche' non si rifacciano
     ==========================================================
     1) LO SCORRIMENTO SCAPPAVA DA SOLO. Misurato: messo a 0, dopo mezzo
        secondo era a 249 e la foto si era chiusa da sola senza che nessuno
        toccasse niente. Non era un errore di conto: e' l'ANCORAGGIO DELLO
        SCORRIMENTO di Chrome, che quando qualcosa sopra la vista cambia
        altezza sposta scrollTop per tenere ferma la roba che stai
        guardando. Solo che qui a cambiare altezza e' proprio la cosa che
        dipende da scrollTop: lui sposta, noi ricalcoliamo, lui risposta.
        Si spegne con overflow-anchor: none in cube-confronto.css - la
        riga e' li' con la sua nota, e non e' un dettaglio estetico.
        Dopo la correzione: 400 resta 400, 150 resta 150, 0 resta 0,
        tenuti fermi cinque secondi ciascuno.

     2) SULLE TABELLE CORTE SI METTEVA A LAMPEGGIARE. Chiudendo
        l'intestazione la pagina si accorcia, quindi lo scorrimento
        massimo cala di altrettanto: se ci si era spinti oltre il nuovo
        massimo il browser riporta indietro scrollTop, la foto si riapre,
        la pagina si rialza, e via cosi'. Misurato: 1466px di contenuto
        che diventano 1212, massimo da 589 a 335.
        Il rimedio e' calcolare la corsa sullo spazio che ci sarebbe A
        INTESTAZIONE CHIUSA - un numero che non cambia mentre la foto si
        muove - e non chiudere affatto quando quello spazio e' meno di
        quaranta pixel: su una tabella cosi' corta non ci sarebbe niente
        da guadagnare. Provato tagliando la tabella a tre righe: la foto
        resta piena e non si muove piu'.

     3) SUL TELEFONO NON SUCCEDEVA NIENTE PER I PRIMI 152 PIXEL, e la
        causa e' istruttiva. All'inizio l'altezza di partenza la leggevo
        dal tetto scritto nel CSS. Sul desktop tornava; sul telefono no,
        perche' li' comandava la larghezza della colonna e non il tetto,
        quindi partivo da un numero piu' grande di quello vero e per due
        terzi di corsa scrivevo misure che non cambiavano niente.
        Adesso l'altezza di partenza si MISURA invece di dedurla: si
        toglie per un istante la misura scritta a mano e si guarda quanto
        e' alta davvero. (Dal 25 agosto la scatola ha anche una forma
        fissa - vedi aspect-ratio in cube-confronto.css - quindi le
        colonne sono alte tutte uguali, ma la misura si continua a fare
        sul posto: cosi' regge qualunque cosa si decida nel CSS.) */

  var pienaNota = 0;

  function pienaFoto() {
    if (pienaNota) return pienaNota;

    var foto = modale.querySelectorAll('.cube-cfr-scheda img');
    if (!foto.length) return 0;

    /* la piu' alta delle foto: e' quella che detta l'altezza della riga,
       le altre le stanno dentro */
    var alta = 0;
    foto.forEach(function (i) {
      var mio = i.style.maxHeight;
      i.style.maxHeight = '';
      var h = i.getBoundingClientRect().height;
      i.style.maxHeight = mio;
      if (h > alta) alta = h;
    });

    /* foto non ancora arrivate: non si registra niente e si riprova al
       prossimo giro, altrimenti resterebbe in memoria un'altezza di zero */
    if (alta < 40) return 0;

    pienaNota = alta;
    return alta;
  }

  function comprimi() {
    if (!modale || modale.hidden) return;

    var corpo = modale.querySelector('.cube-cfr-corpo');
    var foto = modale.querySelectorAll('.cube-cfr-scheda img');
    if (!corpo || !foto.length) return;

    var piena = pienaFoto();
    var daCedere = piena - FOTO_CHIUSA;
    if (daCedere < 40) return;

    /* quanto scorrimento resterebbe a intestazione tutta chiusa. Vale
       uguale in qualsiasi momento: se la foto adesso e' gia' mezza
       chiusa, l'altezza del contenuto e' gia' calata di altrettanto e le
       due correzioni si annullano. E' il numero stabile su cui misurare
       la corsa - vedi l'incidente 2 qui sopra. */
    var ora = parseFloat(modale.dataset.cubeFoto || piena);
    var chiusa = corpo.scrollHeight - (ora - FOTO_CHIUSA) - corpo.clientHeight;

    var corsa = Math.min(daCedere, chiusa);
    var quota = corsa >= 40 ? Math.min(1, Math.max(0, corpo.scrollTop / corsa)) : 0;
    var h = Math.round(piena - daCedere * quota);

    if (String(h) === modale.dataset.cubeFoto) return;
    modale.dataset.cubeFoto = String(h);

    foto.forEach(function (i) { i.style.maxHeight = h + 'px'; });
  }

  /* ---------- la finestra ---------- */

  function creaModale() {
    var m = document.createElement('div');
    m.className = 'cube-cfr-modale';
    m.hidden = true;
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Confronta le bici');
    m.innerHTML =
      '<div class="cube-cfr-testa">' +
        '<span class="cube-cfr-testa__logo" role="img" aria-label="CUBE Store Valtellina"></span>' +
        '<h2 class="cube-cfr-testa__titolo">Confronta le bici</h2>' +
        '<div class="cube-cfr-testa__comandi">' +
          '<button type="button" class="cube-cfr-diff" aria-pressed="false"><span class="cube-cfr-diff__lungo">Mostra differenze</span><span class="cube-cfr-diff__corto">Mostra differenze</span></button>' +
          '<button type="button" class="cube-cfr-chiudi" aria-label="Chiudi">×</button>' +
        '</div>' +
      '</div>' +
      '<div class="cube-cfr-corpo"></div>';

    document.body.appendChild(m);

    m.querySelector('.cube-cfr-chiudi').addEventListener('click', chiudi);

    /* MOSTRA DIFFERENZE (23 ottobre 2026): "voglio aggiungere un tasto
       Mostra differenze dove vengono evidenziate solo le voci diverse" -
       Marco. Non nasconde niente (il filtro che nascondeva le righe uguali
       era stato tolto ad agosto, vedi la nota in testa): accende la classe
       cube-cfr--differenze sulla finestra e il CSS qui sotto colora le
       righe segnate come diverse e schiarisce le altre. Lo stato resta
       acceso riaprendo la finestra nella stessa visita. */
    var diff = m.querySelector('.cube-cfr-diff');
    diff.addEventListener('click', function () {
      var acceso = !m.classList.contains('cube-cfr--differenze');
      m.classList.toggle('cube-cfr--differenze', acceso);
      diff.setAttribute('aria-pressed', acceso ? 'true' : 'false');
    });

    /* lo scorrimento arriva a raffica: si accoda al fotogramma successivo
       invece di ricalcolare a ogni singolo evento */
    var inCoda = false;
    m.querySelector('.cube-cfr-corpo').addEventListener('scroll', function () {
      if (inCoda) return;
      inCoda = true;
      requestAnimationFrame(function () { inCoda = false; comprimi(); });
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modale && !modale.hidden) chiudi();
    });

    return m;
  }

  function chiudi() {
    if (!modale) return;
    modale.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function apri() {
    var elenco = leggi();
    if (elenco.length < 2) return;

    if (!modale) modale = creaModale();
    modale.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var corpo = modale.querySelector('.cube-cfr-corpo');
    corpo.innerHTML = '<p class="cube-cfr-stato">Carico le schede tecniche…</p>';

    Promise.all(elenco.map(function (p) {
      return carica(p.handle).catch(function () { return null; });
    })).then(function (dati) {
      var buoni = dati.filter(Boolean);

      if (buoni.length < 2) {
        corpo.innerHTML = '<p class="cube-cfr-stato">Non sono riuscito a caricare le schede tecniche. Riprova fra un momento.</p>';
        return;
      }

      corpo.textContent = '';
      corpo.appendChild(tabella(buoni));
      impostaIcone(modale, iconeAccese());

      /* tabella nuova: altre foto, altre proporzioni, quindi l'altezza di
         partenza va rimisurata. E si riparte dall'alto, altrimenti le
         foto resterebbero della misura a cui era arrivato lo scorrimento
         della tabella precedente. */
      pienaNota = 0;
      delete modale.dataset.cubeFoto;
      corpo.scrollTop = 0;
      comprimi();

      /* le foto arrivano dal CDN un istante dopo: finche' non sono qui
         non si sa quanto sono alte, e pienaFoto() si rifiuta di
         registrare una misura. Si richiede appena la prima e' pronta. */
      var prima = corpo.querySelector('.cube-cfr-scheda img');
      if (prima && !prima.complete) {
        prima.addEventListener('load', function () { comprimi(); }, { once: true });
      }
    });
  }

  /* ---------- la tabella ---------- */

  /* L'ELENCO DELLE RIGHE E' L'UNIONE, NON L'INTERSEZIONE.
     Se una bici ha "copertone anteriore" e un'altra no, la riga c'e' lo
     stesso e sulla seconda si legge un trattino. Mostrare solo le voci
     che hanno tutti sembrerebbe piu' pulito, ma nasconderebbe proprio le
     differenze - che e' il motivo per cui uno apre un confronto.
     L'ordine dei gruppi e delle righe e' quello del primo prodotto, poi
     si aggiungono in coda le voci che compaiono solo negli altri. */

  function unione(dati) {
    var gruppi = [];
    var indice = {};

    dati.forEach(function (p) {
      (p.gruppi || []).forEach(function (g) {
        if (!indice[g.titolo]) {
          indice[g.titolo] = { titolo: g.titolo, chiavi: [], etichette: {} };
          gruppi.push(indice[g.titolo]);
        }
        var G = indice[g.titolo];
        (g.righe || []).forEach(function (r) {
          if (G.chiavi.indexOf(r.chiave) === -1) {
            G.chiavi.push(r.chiave);
            G.etichette[r.chiave] = r.etichetta;
          }
        });
      });
    });

    return gruppi;
  }

  /* IL VALORE SI RIPULISCE QUI, UNA VOLTA SOLA E PER TUTTI, e non e' una
     precauzione teorica: scoperto il 24 agosto 2026 su una bici vera.

     Il metafield del colore della AMS Hybrid 177 vale
     "\treedbeigegrit´n´orange", con una TABULAZIONE davanti - qualcuno
     l'ha incollato dentro un foglio di calcolo e se l'e' portata dietro.
     Invisibile a schermo, perche' l'HTML gli spazi li accorpa e non si
     vedono. Faceva pero' due danni veri:

     1. nomeModello() confronta la coda del titolo con il colore per
        toglierlo: con la tabulazione in mezzo non combaciava piu' e sulla
        colonna restava "AMS HYBRID 177 C:62 SUPER TM 600X
        reedbeigegrit´n´orange", cioe' proprio quello che era stato
        chiesto di togliere;
     2. PEGGIO: due bici con lo STESSO componente, una col valore pulito e
        una con lo spazio davanti, risultavano diverse. La riga finiva
        segnata come differenza quando differenza non c'era.

     Il secondo danno e' il motivo per cui si ripulisce qui dentro e non
     al momento di stampare il titolo: cosi' vale per ogni voce di ogni
     bici, comprese quelle che confrontiamo, e non solo per il colore.
     Gli spazi interni si accorpano oltre a togliere quelli ai bordi:
     "Sram  XX  Eagle" e "Sram XX Eagle" sono la stessa cosa e devono
     risultare uguali. */

  function valore(prodotto, chiave) {
    var v = '';
    (prodotto.gruppi || []).forEach(function (g) {
      (g.righe || []).forEach(function (r) {
        if (r.chiave === chiave) v = r.valore;
      });
    });
    return String(v == null ? '' : v).replace(/\s+/g, ' ').trim();
  }

  /* ==========================================================
     L'INTESTAZIONE DELLA COLONNA: MODELLO, POI CODICE COLORE PREZZO
     ==========================================================
     Chiesto da Alberto Quadrio il 24 agosto 2026: "si potrebbe togliere
     CUBE, mettere il nome del colore in minuscolo no grassetto ed
     aggiungere il codice. Magari codice a sinistra e prezzo a destra", e
     il giorno dopo la rifinitura: "prezzo e codice puoi metterli a
     sinistra e destra del colore, devi riprendere tipo come si vedono da
     catalogo".

     Prima era una riga sola col titolo intero del prodotto - "CUBE STEREO
     HYBRID ONE44 HPC SLT 800 SPLINTERNAVY´N´PRIZM" - tutta maiuscola e
     grassetta. Con quattro bici affiancate diventava un muro di lettere
     su tre righe in cui il modello, che e' l'unica cosa che si cerca, si
     perdeva in mezzo.

     Adesso sono due righe sole:

       STEREO HYBRID ONE44 HPC SLT 800        il modello, in evidenza
       1103900   splinternavy´n´prizm   €8.499  il resto, su una riga

     "CUBE" via perche' e' un negozio di un marchio solo: ripeterlo su
     ogni colonna non distingue niente, occupa e basta.

     LE STESSE DUE FUNZIONI SERVONO ANCHE ALLE PASTIGLIE della barra in
     fondo (vedi disegna): una regola sola per tutti i posti in cui si
     scrive il nome di una bici, cosi' non possono divergere.

     DA DOVE ARRIVANO codice e colore: dalle righe della scheda tecnica
     che abbiamo gia' in mano - chiavi "codice" e "colore". Non serve
     nessuna richiesta in piu' e non si tocca il file Liquid.

     L'ORDINE IN CUI SI COSTRUISCONO E' QUELLO IN CUI SI LEGGONO - codice,
     colore, prezzo - e il CSS non usa nessun "order" per rimetterli in
     fila: chi legge questo pezzo vede subito come esce a schermo.

     LE DUE RIGHE RESTANO ANCHE NELLA TABELLA sotto, ed e' voluto: la
     colonna delle etichette dice CODICE ARTICOLO e COLORE, e chi scorre
     confrontando le voci se le aspetta al loro posto insieme alle altre.

     SE IL COLORE NON C'E' NEI METAFIELD si ricava dall'ultima parola del
     titolo, con la stessa regola di cube-collection.js e di
     snippets/cube-colore.liquid: se contiene "n" fra due accenti
     (topasblue´n´white) e' un colore; altrimenti vale solo se tutta
     minuscola, lunga almeno cinque lettere e senza cifre (teamline,
     actionteam). I nomi dei modelli CUBE sono maiuscoli o hanno numeri,
     quindi restano nel titolo. Serve sulle dieci bici senza metafield, e
     serve alle pastiglie della barra, che il metafield non ce l'hanno
     mai sottomano. */

  function coloreDaTitolo(titolo) {
    var p = String(titolo || '').trim().split(/\s+/);
    if (p.length < 2) return '';

    var u = p[p.length - 1];

    if (u.indexOf('´n´') === -1) {
      if (u !== u.toLowerCase()) return '';
      if (u.length < 5) return '';
      if (/[0-9]/.test(u)) return '';
    }

    return u;
  }

  function nomeModello(titolo, colore) {
    var t = String(titolo || '').replace(/\s+/g, ' ').replace(/^\s*cube\s+/i, '').trim();

    if (colore && t.length > colore.length &&
        t.slice(-colore.length).toLowerCase() === colore.toLowerCase()) {
      t = t.slice(0, t.length - colore.length).trim();
    }

    return t;
  }

  function tabella(dati) {
    var gruppi = unione(dati);

    if (!gruppi.length) {
      var vuoto = document.createElement('p');
      vuoto.className = 'cube-cfr-stato';
      vuoto.textContent = 'Questi prodotti non hanno ancora una scheda tecnica da confrontare.';
      return vuoto;
    }

    var g = document.createElement('div');
    g.className = 'cube-cfr-griglia';
    g.style.setProperty('--cube-cfr-colonne', dati.length);

    /* intestazione */
    var angolo = document.createElement('div');
    angolo.className = 'cube-cfr-angolo';
    var riduci = document.createElement('button');
    riduci.type = 'button';
    riduci.className = 'cube-cfr-riduci';
    riduci.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 6l-6 6 6 6M19 6l-6 6 6 6"/></svg><span>Riduci menu</span>';
    riduci.addEventListener('click', function () {
      impostaIcone(modale, !modale.classList.contains('cube-cfr--icone'));
    });
    angolo.appendChild(riduci);
    g.appendChild(angolo);

    dati.forEach(function (p) {
      var s = document.createElement('div');
      s.className = 'cube-cfr-scheda';

      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'cube-cfr-scheda__togli';
      x.textContent = 'Rimuovi';
      x.addEventListener('click', function () { togli(p.handle); });
      s.appendChild(x);

      if (p.immagine) {
        var i = document.createElement('img');
        i.src = p.immagine;
        i.alt = p.titolo;
        i.loading = 'lazy';
        s.appendChild(i);
      }

      var colore = valore(p, 'colore') || coloreDaTitolo(p.titolo);
      var codice = valore(p, 'codice');

      var a = document.createElement('a');
      a.className = 'cube-cfr-scheda__nome';
      a.href = p.url;
      a.textContent = nomeModello(p.titolo, colore);
      s.appendChild(a);

      /* CODICE, COLORE E PREZZO SU UNA RIGA SOLA, nell'ordine in cui si
         leggono. Il colore sta in mezzo e si prende lo spazio che avanza
         (e' lui ad avere flex: 1 nel CSS), quindi resta centrato sotto la
         foto qualunque sia la lunghezza degli altri due.

         Il prezzo tiene comunque il suo margine automatico a sinistra:
         serve sulle dieci bici senza metafield, dove colore e codice non
         ci sono e senza quel margine il prezzo si appoggerebbe a
         sinistra invece che a destra. */
      var riga = document.createElement('div');
      riga.className = 'cube-cfr-scheda__riga';

      if (codice) {
        var cod = document.createElement('span');
        cod.className = 'cube-cfr-scheda__codice';
        cod.textContent = codice;
        riga.appendChild(cod);
      }

      if (colore) {
        var col = document.createElement('span');
        col.className = 'cube-cfr-scheda__colore';
        col.textContent = colore;
        riga.appendChild(col);
      }

      var pr = document.createElement('span');
      pr.className = 'cube-cfr-scheda__prezzo';
      pr.textContent = p.prezzo;
      if (p.prezzoListino) {
        var l = document.createElement('span');
        l.className = 'cube-cfr-scheda__listino';
        l.textContent = p.prezzoListino;
        pr.appendChild(l);
      }
      riga.appendChild(pr);

      s.appendChild(riga);
      g.appendChild(s);
    });

    /* LE RIGHE, DI SEGUITO E SENZA TITOLI DI GRUPPO.
       Fino al 20 agosto 2026 ogni gruppo si apriva con una fascia nera -
       BICI, PESO E PORTATA, TELAIO E SOSPENSIONI - tolte su richiesta:
       "non importano a nessuno".
       I gruppi pero' si continuano a percorrere in ordine, ed e' il
       motivo per cui questo ciclo e' ancora annidato: senza, le righe
       uscirebbero nell'ordine in cui i metafield capitano invece che in
       quello della scheda tecnica. Sparisce l'intestazione, non
       l'organizzazione.

       LA CLASSE SULLE RIGHE CHE DIFFERISCONO SI CONTINUA A METTERE anche
       se dal 24 agosto nessuno la dipinge piu' (il filo azzurro e' stato
       tolto su richiesta). Costa una riga e tiene aperta la porta: per
       rimettere l'evidenziazione in qualunque forma basta una regola CSS
       su cube-cfr-riga--diversa, senza toccare niente qui.
       Il confronto e' affidabile perche' i valori arrivano gia' ripuliti
       da valore(): vedi la nota li' sopra, con la bici che sballava. */
    var quanteDiverse = 0;

    gruppi.forEach(function (gruppo) {
      gruppo.chiavi.forEach(function (chiave) {
        var valori = dati.map(function (p) { return valore(p, chiave); });
        var diverse = valori.some(function (v) { return v !== valori[0]; });

        var et = document.createElement('div');
        et.className = 'cube-cfr-et';
        var nomeVoce = gruppo.etichette[chiave] || chiave;
        et.dataset.et = nomeVoce;
        et.dataset.chiave = chiave;
        et.tabIndex = 0;
        et.innerHTML = '<span class="cube-cfr-et__icona">' + icona(chiave) + '</span>';
        var testoVoce = document.createElement('span');
        testoVoce.className = 'cube-cfr-et__testo';
        testoVoce.textContent = nomeVoce;
        et.appendChild(testoVoce);
        if (diverse) et.classList.add('cube-cfr-riga--diversa');
        g.appendChild(et);

        if (diverse) quanteDiverse++;

        valori.forEach(function (v) {
          var c = document.createElement('div');
          c.className = 'cube-cfr-val';
          if (diverse) c.classList.add('cube-cfr-val--diversa');
          if (v) {
            c.textContent = v;
          } else {
            c.textContent = '—';
            c.classList.add('cube-cfr-val--vuoto');
          }
          g.appendChild(c);
        });
      });
    });

    /* il numero delle voci diverse sul tasto della testata */
    var tasto = modale && modale.querySelector('.cube-cfr-diff');
    if (tasto) {
      /* due scritte: lunga da computer, corta da telefono (il CSS ne
         mostra una), cosi' da telefono logo e tasti stanno su una riga */
      var html = quanteDiverse
        ? '<span class="cube-cfr-diff__lungo">Mostra differenze (' + quanteDiverse + ')</span><span class="cube-cfr-diff__corto">Mostra differenze (' + quanteDiverse + ')</span>'
        : '<span class="cube-cfr-diff__lungo">Nessuna differenza</span><span class="cube-cfr-diff__corto">Nessuna differenza</span>';
      if (tasto.innerHTML !== html) tasto.innerHTML = html;
      tasto.disabled = !quanteDiverse;
    }

    return g;
  }

  /* ---------- avvio ---------- */

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      montaBottoni();
      posizionaBarra();
    });
  }

  /* apertura da indirizzo: vedi la nota in testa al file */
  function daIndirizzo() {
    var m = location.search.match(new RegExp('[?&]' + PARAM + '=([^&]+)'));
    if (!m) return;

    var handles = decodeURIComponent(m[1]).split(',').filter(Boolean).slice(0, MAX);
    if (handles.length < 2) return;

    Promise.all(handles.map(function (h) {
      return carica(h).catch(function () { return null; });
    })).then(function (dati) {
      var elenco = dati.filter(Boolean).map(function (d) {
        return { handle: d.handle, titolo: d.titolo, immagine: d.immagine };
      });
      if (elenco.length < 2) return;
      scrivi(elenco);
      apri();
    });
  }

  function avvia() {
    montaBottoni();
    disegna();
    daIndirizzo();

    if (!document.body) return;
    /* l'app Globo ridisegna le schede a ogni filtro applicato: i bottoni
       vanno rimessi. La chat di Gorgias arriva tardi e per conto suo, e
       questo osservatore la intercetta quando compare.
       Si guarda solo childList - aggiungere un bottone e' una modifica di
       figli, ma il controllo "ce l'ha gia'?" in montaBottoni impedisce il
       cerchio, e sia posizionaBarra sia spostaChat scrivono solo quando il
       valore cambia davvero. */
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });

    /* girando il telefono cambiano sia la larghezza della colonna sia
       25vh, quindi l'altezza di partenza misurata non vale piu': si butta
       e si rimisura al primo ricalcolo */
    window.addEventListener('resize', function () {
      posizionaBarra();
      pienaNota = 0;
      if (modale) delete modale.dataset.cubeFoto;
      comprimi();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
